const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRecordNormal(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1320",
    d: "M473.278 16.283a6.439 6.439 0 1 0 6.439 6.439 6.447 6.447 0 0 0-6.439-6.439zm0 10.878a4.439 4.439 0 1 1 4.439-4.439 4.444 4.444 0 0 1-4.439 4.439z",
    style: {
      fill: "current"
    },
    transform: "translate(-455.278 -4.722)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1321",
    d: "M473.278 8.722a14 14 0 1 0 14 14 14.015 14.015 0 0 0-14-14zm0 26a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12z",
    style: {
      fill: "current"
    },
    transform: "translate(-455.278 -4.722)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordNormal);
export default __webpack_public_path__ + "static/media/icon-record-normal.3dc363469621f829da40b4299c7cd59d.svg";
export { ForwardRef as ReactComponent };